import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';

import * as L from 'leaflet';

import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { LocationService } from './../../../_services/location.service';
import { AuthService } from 'src/app/modules/_services/auth.service';
@Component({
  selector: 'app-localizacao',
  templateUrl: './localizacao.component.html',
  styleUrls: ['./localizacao.component.scss'],
})
export class LocalizacaoComponent implements OnInit {
  @Input() public exibirModal: boolean = true;
  @Input() public idExperiencia: any;
  @Input() public imagemParceiro: string;

  @Output() public fecharCardLocalizacao: EventEmitter<null> =
    new EventEmitter();

  @ViewChild('cep') cepValor: ElementRef;
  @ViewChild('numero') numeroValor: ElementRef;

  // ** CONSTANTS ** //
  private readonly LATITUDE_DEFAULT: number = -23.52;
  private readonly LONGITUDE_DEFAULT: number = -46.97;
  private readonly ID_MAPA: string = 'map';
  private readonly ZOM_INICIAL: number = 13;
  private readonly ZOM_MAXIMO: number = 18;
  private readonly ZOM_MINIMO: number = 3;
  private readonly URL_GOOGLE_MAPS: string =
    'https://www.google.com/maps/search/?api=1&query=';
  private map: L.map;

  public listaEndereco: any;

  constructor(
    private fidelidadeService: FidelidadeService,
    private locationService: LocationService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {}

  public abrirModal() {
    if (this.exibirModal) this.iniciarMapa();

    return this.exibirModal;
  }

  public fecharCard(): void {
    this.fecharCardLocalizacao.emit();
  }

  public buscarEndereco(): void {
    const cep = <HTMLInputElement>document.getElementById('cep');
    const numero = <HTMLInputElement>document.getElementById('numero');

    if (!cep.value || !numero.value) return;

    const cepFormatado = cep.value.replace(/\D/g, '');

    if (cepFormatado.length < 8) return;

    this.authService.loginOms().subscribe({
      next: (token: any) => {
        this.locationService
          .obterEndereco(token.token, cepFormatado, numero.value)
          .subscribe({
            next: (res: any) => this.processarSucessoObterEndereco(res),
            error: (err: any) => this.processarFalhaObterEndereco(err),
          });
      },
    });
  }

  public habilitarBotaoPesquisa(): boolean {
    if (!this.cepValor || !this.numeroValor) return true;

    if (!this.cepValor.nativeElement.value) return true;
    const cepFormatado = this.cepValor.nativeElement.value.replace(/\D/g, '');

    if (cepFormatado.length < 8) return true;

    return false;
  }

  public obterLocalizacaoAtual() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.buscarEnderecosProximos(
          position.coords.latitude,
          position.coords.longitude
        );
      });
    } else {
      console.warn('O navegador nao suporta essa configuracao');
    }
  }

  public irParaEndereco(latitude: any, longitude: any) {
    this.centralizarMapa(latitude, longitude, 15);
  }

  public formatarValorParaDuasCasasDecimais(valor: number): string {
    return valor.toFixed(2);
  }

  public redirectGoogleMaps(latitude: any, longitude: any) {
    const url = this.URL_GOOGLE_MAPS + latitude + ',' + longitude;
    window.open(url, '_blank');
  }

  // ** Metodos Privados de Apoio ** //
  private iniciarMapa(): void {
    const element = document.getElementById(this.ID_MAPA);
    // se o elemento nao existir retorna
    if (element == null || element == undefined) return;
    // se o mapa ja estiver estanciando retorna
    if (this.map) return;
    // adiciona o icone default ao mapa
    this.adicionarIconeMapa();
    // localizacao inicial
    this.map = L.map(this.ID_MAPA, {
      center: [this.LATITUDE_DEFAULT, this.LONGITUDE_DEFAULT],
      zoom: this.ZOM_INICIAL,
    });

    const tiles = L.tileLayer(
      'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      {
        maxZoom: this.ZOM_MAXIMO,
        minZoom: this.ZOM_MINIMO,
        attribution:
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }
    );

    tiles.addTo(this.map);
    //obtem permissao para obter localizacao
    this.obterLocalizacaoAtual();
  }

  private centralizarMapa(
    latitude: number,
    longitude: number,
    zoom: number = this.ZOM_INICIAL
  ) {
    const centroMapa = { lat: latitude, lng: longitude };
    this.map.setView(centroMapa, zoom);
  }

  private adicionarIconeMapa() {
    var iconDefault = L.icon({
      iconRetinaUrl: 'assets/images/icons/location_red.png',
      iconUrl: 'assets/images/icons/location_red.png',
      shadowUrl: 'assets/marker-shadow.png',
      iconSize: [26, 34],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [41, 41],
    });

    L.Marker.prototype.options.icon = iconDefault;
  }

  // ** Metodos Privados de Serviço ** //
  private buscarEnderecosProximos(latitude: number, longitude: number) {
    this.fidelidadeService
      .obterListaEnderecosProximos(this.idExperiencia, latitude, longitude)
      .subscribe({
        next: (res: any) => {
          this.processarSucessoObterListaEndereco(res);
          this.centralizarMapa(latitude, longitude);
        },
        error: (err: any) => {
          this.processarFalhaObterListaEndereco(err);
          this.centralizarMapa(this.LATITUDE_DEFAULT, this.LONGITUDE_DEFAULT);
        },
      });
  }

  // ** Metodos Privados de Sucesso e Insucesso de requisição ** //
  private processarSucessoObterListaEndereco(success: any) {
    const enderecos: any[] = [];

    success.resultado.forEach((parceiroEndereco: any) => {
      const endereco = {
        ...parceiroEndereco.endereco,
        descricao: parceiroEndereco.descricao,
      };

      enderecos.push(endereco);
    });

    this.listaEndereco = enderecos;

    for (const item of success.resultado) {
      const marker = L.marker([item.endereco.latitude, item.endereco.longitude]);
      marker.addTo(this.map);
    }
  }

  private processarFalhaObterListaEndereco(err: any) {
    console.error('Erro ao obter lista de endereco proximos', err);

    const marker = L.marker([this.LATITUDE_DEFAULT, this.LONGITUDE_DEFAULT]);

    marker.addTo(this.map);
  }

  processarSucessoObterEndereco(success: any) {
    this.buscarEnderecosProximos(success[0].latitude, success[0].longitude);
  }

  processarFalhaObterEndereco(err: any) {
    console.error('Ocorreu um erro ao tentar obter o endereço', err);
  }
}
